import { render } from "./Task.vue?vue&type=template&id=c14049de"
import script from "../assets/js/task.js?vue&type=script&lang=js"
export * from "../assets/js/task.js?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\DWEC\\projects\\ToDoList\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__